// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__Z0nlS","subheader":"ReorderModal_subheader__1r7y3","listWrap":"ReorderModal_listWrap__2ORHI"};